import React from 'react';
import PropTypes from 'prop-types';
import loading from '../assets/loading.svg';

function Loading({ fullPage = false }) {
  return (
    <div className={fullPage ? 'spinner spinner--full-page' : 'spinner'}>
      <img src={loading} alt="Loading" />
    </div>
  );
}

Loading.propTypes = {
  fullPage: PropTypes.bool,
};

export default Loading;
